import React from 'react';
import bars from '../../assets/partners/barsgroup.svg';
import tkb from '../../assets/partners/tkb.svg';
import onder from '../../assets/partners/onder.svg';
import rosatom from '../../assets/partners/rosatom.svg';
import games from '../../assets/partners/fg.svg';
import brics from '../../assets/partners/brics.svg';
import innostage from '../../assets/partners/Innostage.png';
import balacity from '../../assets/partners/balaCity.png';
import './Partners.css';

const partners = [
  {
    name: 'Росатом', image: rosatom, url: 'https://rosatom.ru/', className: 'partner-logo--rosatom',
  },
  {
    name: 'ТКБ Банк (Транскапиталбанк)', image: tkb, url: 'https://www.tkbbank.ru/', className: 'partner-logo--tkb',
  },
  {
    name: 'БАРС Груп', image: bars, url: 'https://bars.group/', className: 'partner-logo--bars',
  },
  {
    name: 'Innostage', image: innostage, url: 'https://innostage-group.ru/', className: 'partner-logo--innostage',
  },
  {
    name: 'BRICS Games', image: brics, url: 'https://bricskazan2024.games/', className: 'partner-logo--brics',
  },
  {
    name: 'Games of the Future', image: games, url: 'https://gofuture.games/', className: 'partner-logo--games',
  },
  {
    name: 'ONDER', image: onder, url: 'https://onder.tech/', className: 'partner-logo--onder',
  },
  {
    name: 'БАЛА-СИТИ', image: balacity, url: 'https://www.balacity.ru/', className: 'partner-logo--balacity',
  },
];

const PartnersMarquee: React.FC = () => (
  <section
    aria-label="Наши партнёры"
    className="partners"
    id="Partners"
  >
    <svg
      aria-hidden="true"
      className="partner-filters"
      focusable="false"
    >
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          height="100%"
          id="partner-balacity-mark"
          width="100%"
          x="0"
          y="0"
        >
          <feColorMatrix
            type="matrix"
            values=".383 1.287 .13 0 -.2  .383 1.287 .13 0 -.2  .383 1.287 .13 0 -.2  -1 -1 -1 0 3"
          />
          <feComposite
            in2="SourceAlpha"
            operator="in"
          />
        </filter>
      </defs>
    </svg>
    <div className="landing-container partners-inner">
      <p className="footer-cta-kicker partners-heading">
        <span className="section-index">06 /</span>
        {' '}
        Наши партнёры
      </p>
      <ul className="partner-grid">
        {partners.map((partner) => (
          <li key={partner.name}>
            <a
              className={['partner-logo', partner.className].filter(Boolean).join(' ')}
              href={partner.url}
              rel="noreferrer"
              target="_blank"
            >
              <img
                alt={partner.name}
                src={partner.image}
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default PartnersMarquee;
